import { ContentBlock, FlexGap, FlexJustify, Padding, useLayout, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { faLocationCrosshairs } from '@fortawesome/pro-solid-svg-icons/faLocationCrosshairs';
import { useMailbox } from '../../../../Mailboxes/Providers/NewMailboxProvider';

function MailItemEnclosuresMeta() {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();

	const { mailItemData } = useMailbox();

	if (
		mailItemData?.enclosures === '' ||
		mailItemData?.enclosures === null ||
		mailItemData?.enclosures === undefined
	) {
		return null;
	}

	return (
		<ContentBlock
			title={t('mailItem.labels.enclosures')}
			content={mailItemData?.enclosures}
			padding={Padding.ExtraSmall}
			iconContent={{ icon: faLocationCrosshairs, iconSpacing: FlexGap.Small, iconSize: 'lg' }}
			stacked
			justify={FlexJustify.Start}
		/>
	);
}

export { MailItemEnclosuresMeta };
